"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMembersValidation = void 0;
var utils_1 = require("./utils");
function getMembersValidation(getMembersRequest) {
    var errorList = [];
    var params = getMembersRequest.params;
    if (!params.mallNo) {
        utils_1.addErrorList(errorList, 'mallNo', 'MEMBER_LIST_MALLNO_ISNULL_ERROR');
    }
    if (!params.page) {
        utils_1.addErrorList(errorList, 'page', 'MEMBER_LIST_PAGE_ISNULL_ERROR');
    }
    if (!params.pageSize) {
        utils_1.addErrorList(errorList, 'pageSize', 'MEMBER_LIST_PAGESIZE_ISNULL_ERROR');
    }
    return errorList;
}
exports.getMembersValidation = getMembersValidation;
